export default {
    methods: {
        isMobile() {
            /* eslint-disable */
            if (
                /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                    navigator.userAgent
                ) ||
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                    navigator.userAgent
                )
            ) {
                return true;
            } else {
                return false;
            }
            /* eslint-enable */
        },
        capitalizeFirstLetter(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },
        isNumeric(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        },
        icPriceFormat(num, hideCurrency = false) {
            let priceConfig;
            if (hideCurrency) {
                priceConfig = {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                };
            } else {
                priceConfig = { style: "currency", currency: "USD" };
            }
            if (this.isNumeric(num)) {
                return new Intl.NumberFormat("en-US", priceConfig).format(
                    parseFloat(num)
                );
            }
        },
        toTitleCase(str) {
            const words = str.split(/[_\- ]+/);
            const capitalizedWords = words.map(
                (word) => word.charAt(0).toUpperCase() + word.slice(1)
            );
            const capitalizedStr = capitalizedWords.join(" ");
            return capitalizedStr;
        },
        toSnakeCase(str) {
            // Replace spaces, hyphens, and camel case with underscores
            const snakeCaseStr = str.replace(
                /\s+|[-]|([a-z])([A-Z])/g,
                (_, a, b) => {
                    if (a && b) {
                        return a + "_" + b.toLowerCase();
                    } else {
                        return "_";
                    }
                }
            );

            const lowercaseStr = snakeCaseStr.toLowerCase();
            return lowercaseStr;
        },
        removeEmptyKeys(obj) {
            for (let key in obj) {
                const value = obj[key];

                if (
                    value === undefined ||
                    value === null ||
                    (Array.isArray(value) && value.length === 0)
                ) {
                    delete obj[key];
                }
            }

            return obj;
        },
        groupArrayOfObjects(list, key) {
            return list.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        },
        isRGB(string) {
            return /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/.exec(
                string
            );
        },
        rgbToHex(rgbColorString) {
            const rgbValues = rgbColorString.match(/\d+/g);

            if (!rgbValues || rgbValues.length != 3) {
                return rgbColorString;
            }

            let r = parseInt(rgbValues[0], 10); // Red value
            let g = parseInt(rgbValues[1], 10); // Green value
            let b = parseInt(rgbValues[2], 10); // Blue value

            // Ensure that the values are within the valid range (0-255)
            r = Math.max(0, Math.min(255, r));
            g = Math.max(0, Math.min(255, g));
            b = Math.max(0, Math.min(255, b));

            // Convert each component to a hexadecimal string
            const redHex = r.toString(16).padStart(2, "0");
            const greenHex = g.toString(16).padStart(2, "0");
            const blueHex = b.toString(16).padStart(2, "0");

            // Combine the hexadecimal values to form the HEX color code
            const hexCode = `#${redHex}${greenHex}${blueHex}`;

            return hexCode.toUpperCase(); // Optional: Convert to uppercase for consistency
        },
        sizesArrangmentSorting(all_sizes) {
            var all_product_sizes = [
                "XS",
                "S",
                "M",
                "L",
                "XL",
                "XXL",
                "2XL",
                "3XL",
                "4XL",
                "5XL",
                "6XL",
                "7XL",
                "8XL",
                "9XL",
                "10XL",
                "11XL",
                "12XL",
                "13XL",
                "14XL",
                "OSFM",
                "YXS",
                "YS",
                "YM",
                "YL",
                "YXL",
                "1T",
                "2T",
                "3T",
                "4T",
                "5T",
                "6T",
                "S/M",
                "M/L",
                "L/XL",
                "XL/2XL",
                "2XL/3XL",
                "3XL/4XL",
                "4XL/5XL",
                "4XL/5XL",
                "S/XL",
                "LT",
                "XLT",
                "2XLT",
                "3XLT",
                "4XLT",
                "XSS",
                "2XSS",
                "SS",
                "MS",
                "LS",
                "XLS",
                "2XLS",
                "XSP",
                "2XSP",
                "SP",
                "MP",
                "LP",
                "XLP",
                "2XLP"
            ];
            all_sizes.forEach((size) => {
                if (!all_product_sizes.includes(size)) {
                    all_product_sizes.push(size);
                }
            });

            //the array which will loose some items
            var ar1 = all_product_sizes;
            //the array which is the template
            var ar2 = all_sizes;

            var tmpar = [];

            for (var i = 0; i < ar1.length; i++) {
                if (ar2.indexOf(ar1[i]) !== -1) {
                    tmpar.push(ar1[i]);
                }
            }

            ar1 = tmpar;

            return ar1;
        },
        isEmpty(value) {
            if (!value) return true;

            if (
                ["object", "string"].includes(typeof value) &&
                value.length !== undefined
            ) {
                return value.length > 0 ? false : true;
            }

            if (typeof value === "object") {
                return Object.keys(value).length > 0 ? false : true;
            }
        }
    }
};
